import { Mutation as Schema } from '@/API/Client/Schema';
import { Mutation, MutationSocialSignInArgs } from '@/API/Client/Types/graphql';

import useMutation from './useMutation';

type Type = Pick<Mutation, 'SocialSignIn'>;

type Props = Parameters<typeof useMutation<Type, MutationSocialSignInArgs>>[1];

const { SocialSignIn } = Schema;

const useSocialSignIn = (props?: Props) => {
  const mutation = useMutation<Type, MutationSocialSignInArgs>(
    SocialSignIn,
    props
  );

  return mutation;
};

export { useSocialSignIn, type Type, type Props };
export default SocialSignIn;
